<section class="decision-list" *ngIf="!loading && !error; else listState">
  <header class="decision-list__header">
    <div>
      <p class="decision-list__eyebrow">{{ lang.translate('home.decisionList.eyebrow') }}</p>
      <h2 class="decision-list__title">{{ lang.translate(titleKey) }}</h2>
    </div>
    <span class="decision-list__count" *ngIf="page">{{ page.totalItems }}</span>
  </header>

  <div class="decision-list__empty" *ngIf="!page?.items?.length">
    {{ lang.translate(emptyKey) }}
  </div>

  <div class="decision-list__items" *ngIf="page?.items?.length">
    <button
      type="button"
      class="decision-list__item"
      *ngFor="let item of page?.items; trackBy: trackByDecisionId"
      [class.decision-list__item--selected]="selectedDecisionId === item.decisionId"
      [attr.data-state]="item.state"
      (click)="onSelectDecision(item.decisionId)"
    >
      <div class="decision-list__item-head">
        <span class="decision-list__item-state">{{ getStateLabel(item.state) }}</span>
        <span class="decision-list__item-date" *ngIf="item.dueAt">{{ item.dueAt | date: 'shortDate' }}</span>
      </div>

      <h3 class="decision-list__item-title">{{ formatDecisionTitle(item.title) }}</h3>
      <p class="decision-list__item-reason">{{ item.shortReason }}</p>

      <div class="decision-list__item-meta">
        <span *ngIf="getActionMetaLabel(item) as actionMetaLabel">{{ actionMetaLabel }}</span>
        <span *ngIf="item.owner?.displayName">{{ item.owner?.displayName }}</span>
        <span>{{ getPriorityMetaLabel(item) }}</span>
      </div>
    </button>
  </div>
</section>

<ng-template #listState>
  <div class="decision-list decision-list--state" *ngIf="error; else listLoading">
    <p class="decision-list__state-title">{{ error.title }}</p>
    <p class="decision-list__state-copy">{{ error.message }}</p>
    <button type="button" class="btn btn-outline-primary" (click)="onRetry()">
      {{ lang.translate('home.general.retry') }}
    </button>
  </div>

  <ng-template #listLoading>
    <div class="decision-list decision-list--state" role="status">
      <p class="decision-list__state-copy">{{ lang.translate('home.general.loading') }}</p>
    </div>
  </ng-template>
</ng-template>
